module.exports = __webpack_public_path__ + "img/car-coverage.517b330d.svg";